import { useCallback, useEffect } from "react";

import { PlayerWebRTC } from "@blacknut/playerwebrtc";
import {
  FocusableSection,
  inputUI,
  useForceFocusOnMount,
} from "@blacknut/spatialnav-sdk/dist";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "@blacknut/react-sdk/dist";
import styles from "./styles.module.scss";

interface VideoOverlayProps {
  onRequestClose: () => void;
  onExitPressed: () => void;
  player: PlayerWebRTC;
  isPlayerPlaying: boolean;
}

const VideoOverlay = ({
  onExitPressed,
  onRequestClose,
  player,
  isPlayerPlaying,
}: VideoOverlayProps) => {
  const { t } = useTranslation();

  const _onRequestClose = useCallback(() => {
    player.bind(); // mouse & keyboard events
    inputUI.gameMode = true;
    onRequestClose();
  }, [player, onRequestClose]);

  useEffect(() => {
    player.unBind(); // mouse & keyboard events
    inputUI.gameMode = false;
  }, [player]);

  if (!isPlayerPlaying) return null;
  return (
    <Modal isOpen defaultFocus={`.${styles.exit}`} addButtons={false}>
      <div className={styles.container}>
        <Button className={styles.resume} onClick={_onRequestClose}>
          {t("exitGame.buttons.back")}
        </Button>
        <Button className={styles.exit} onClick={onExitPressed} variant="secondary">
          {t("exitGame.buttons.exit")}
        </Button>
      </div>
    </Modal>
  );
};
export default VideoOverlay;
